export class MarketAssumedValuesBase {
  name: string;
  code: string;
  marketTypeCode: string;
  displayStartDate?: Date;
  displayEndDate?: Date;
  effectiveStartDate?: Date;
  effectiveEndDate?: Date;
  inUse: boolean;
}
